import React, { useState } from 'react';
import { User } from '../../types/auth';
import BalanceChart from './BalanceChart';
import HoldingsTable from './HoldingsTable';
import ActionButtons from './ActionButtons';
import BuyModal from '../Trading/BuyModal';
import SellModal from '../Trading/SellModal';
import DepositModal from '../Payments/DepositModal';
import WithdrawModal from '../Payments/WithdrawModal';

interface DashboardProps {
  user: User;
}

type Modal = 'buy' | 'sell' | 'deposit' | 'withdraw' | null;

export default function Dashboard({ user }: DashboardProps) {
  const [modal, setModal] = useState<Modal>(null);
  const [activeTicker, setActiveTicker] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleBuy = (ticker = '') => {
    setActiveTicker(ticker);
    setModal('buy');
  };

  const handleSell = (ticker = '') => {
    setActiveTicker(ticker);
    setModal('sell');
  };

  const handleTradeSuccess = () => {
    setRefreshKey(k => k + 1);
  };

  const displayName =
    user.email ||
    (user.walletAddress
      ? `${user.walletAddress.slice(0, 6)}…${user.walletAddress.slice(-4)}`
      : 'User');

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2 className="dashboard-welcome">Welcome back, {displayName}</h2>
        <ActionButtons
          onBuy={() => handleBuy()}
          onSell={() => handleSell()}
          onDeposit={() => setModal('deposit')}
          onWithdraw={() => setModal('withdraw')}
        />
      </div>

      <BalanceChart userId={user.id} />

      <HoldingsTable
        refreshKey={refreshKey}
        userId={user.id}
        onBuy={handleBuy}
        onSell={handleSell}
      />

      {modal === 'buy' && (
        <BuyModal
          defaultTicker={activeTicker}
          onClose={() => setModal(null)}
          onSuccess={handleTradeSuccess}
        />
      )}
      {modal === 'sell' && (
        <SellModal
          defaultTicker={activeTicker}
          onClose={() => setModal(null)}
          onSuccess={handleTradeSuccess}
        />
      )}
      {modal === 'deposit' && <DepositModal onClose={() => setModal(null)} />}
      {modal === 'withdraw' && <WithdrawModal onClose={() => setModal(null)} />}
    </div>
  );
}
